import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MaterialModule } from '@app/shared/material.module'
import { Select, Store } from '@ngxs/store'
import { QuoteSessionState } from '@app/shared/store/quote-session/quote-session.state'
import { QuoteSessionAction } from '@app/shared/store/quote-session/quote-session.actions'
import { debounceTime, map, Observable, pairwise, startWith, Subject, takeUntil } from 'rxjs'
import { Contact } from '@app/models/contact'
import { FormControl, ReactiveFormsModule } from '@angular/forms'

@Component({
	selector: 'app-quote-important-notes',
	standalone: true,
	imports: [CommonModule, MaterialModule, ReactiveFormsModule],
	templateUrl: './quote-important-notes.component.html',
	styleUrls: ['./quote-important-notes.component.scss'],
})
export class QuoteImportantNotesComponent implements OnInit, OnDestroy {
	@Select(QuoteSessionState.contactState)
	public contact$!: Observable<Contact>

	public petParentImportantNotes: FormControl<string | null>
	public displayImportantNotes: boolean = true
	public contactFullName$: Observable<string>

	#ngUnsubscribe$: Subject<void> = new Subject()

	constructor(private readonly store: Store) {
		this.contactFullName$ = this.contact$.pipe(
			map((c) => `${c?.firstName ?? 'Pet'} ${c?.lastName ?? 'Parent'}`)
		)

		this.petParentImportantNotes = new FormControl()
	}

	@HostBinding('class')
	public get klassList(): string {
		return this.displayImportantNotes ? 'm--full-height' : ''
	}

	ngOnInit(): void {
		this.contact$
			.pipe(
				map((c) => c.ratingState),
				startWith(null),
				pairwise(),
				takeUntil(this.#ngUnsubscribe$)
			)
			.subscribe(([p, n]) => {
				if (!!p && !n) {
					this.petParentImportantNotes.reset(null, { emitEvent: false })
				}
			})

		this.contact$.pipe(takeUntil(this.#ngUnsubscribe$)).subscribe((contact) => {
			this.petParentImportantNotes.setValue(contact?.importantNotes ?? '', { emitEvent: false })
		})

		this.petParentImportantNotes.valueChanges
			.pipe(takeUntil(this.#ngUnsubscribe$), debounceTime(500))
			.subscribe((n) => {
				this.store.dispatch(new QuoteSessionAction.Contact.Update({ importantNotes: n ?? '' }))
			})
	}

	ngOnDestroy(): void {
		this.#ngUnsubscribe$.next()
		this.#ngUnsubscribe$.unsubscribe()
	}
}
